import { SVGProps } from "react"

interface PrintSvgProps extends SVGProps<SVGSVGElement> {
  fill?: string;
}

const PrintSvg = ({ fill = "#084E8B", ...props }: PrintSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill={fill}
      d="M16 8V5H8v3H6V3h12v5h-2Zm2 4.5a.968.968 0 0 0 .713-.288A.964.964 0 0 0 19 11.5a.973.973 0 0 0-.288-.712A.965.965 0 0 0 18 10.5a.965.965 0 0 0-.712.288.973.973 0 0 0-.288.712c0 .283.095.52.288.713A.96.96 0 0 0 18 12.5ZM16 19v-4H8v4h8Zm2 2H6v-4H2v-6c0-.85.292-1.562.875-2.137S4.167 8.001 5 8h14c.85 0 1.563.288 2.138.863S22.001 10.151 22 11v6h-4v4Zm2-6v-4a.965.965 0 0 0-.288-.712A.973.973 0 0 0 19 10H5a.965.965 0 0 0-.712.288A.972.972 0 0 0 4 11v4h2v-2h12v2h2Z"
    />
  </svg>
)
export default PrintSvg
